import axios from 'axios';
import {apiUrl} from './apiAmbiente';
import {CHAVE_SESSAO} from './sessaoUsuario';
export async function consultarPermuta(dados){
 const fd=new FormData();fd.set('token',sessionStorage.getItem(CHAVE_SESSAO)||'');fd.set('acao','extrato');Object.entries(dados).forEach(([k,v])=>fd.set(k,String(v)));
 try{const {data}=await axios.post(apiUrl('PermutaCliente.php'),fd);if(!data?.ok)throw new Error(data?.erro||'Permuta não consultada.');return data;}
 catch(e){throw new Error(e.response?.data?.erro||e.message||'Não foi possível consultar a permuta.');}
}
